import { ACCT_ALREADY_EXISTS_OKTA_ERROR_KEY } from "../siginin-widget/constants/okta-constants";
export var isAcctAlreadyExistsError = function (error) {
    var _a, _b, _c;
    return !!((_c = (_b = (_a = error === null || error === void 0 ? void 0 : error.xhr) === null || _a === void 0 ? void 0 : _a.responseJSON) === null || _b === void 0 ? void 0 : _b.errorCauses) === null || _c === void 0 ? void 0 : _c.some(function (errorCause) {
        return errorCause.errorKey.includes(ACCT_ALREADY_EXISTS_OKTA_ERROR_KEY);
    }));
};
